var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("\n  "+_vm._s(_vm.creditCard.brand)+"\n  "+_vm._s(_vm.$tt('customCreditCardLast4'))+"\n  "+_vm._s(_vm.creditCard.last4)+"\n  ∙\n  "+_vm._s(_vm.getExpireText())+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }